import {
	connectSearchBox,
	connectPagination,
	connectMenu
 } from '../../../../../dist/vendor/instantsearch.js/es/connectors/index.js';
import { widget as voiceSearch } from './voiceSearch.js';
import { widget as pagination } from './pagination.js';
import { widget as clearRefinements } from './clearRefinements.js';
import { widget as currentRefinements } from './currentRefinements.js';
import { widget as searchBox } from './searchBox.js';
import { widget as hits } from './hits.js';
import { widget as autocomplete } from './autocomplete.js';

const virtualSearchBox = connectSearchBox(() => {});
const virtualPagination = connectPagination(() => {});
const virtualMenu = connectMenu(() => {});

export const widgets = {
	autocomplete,
	voiceSearch,
	pagination,
	clearRefinements,
	currentRefinements,
	searchBox,
	hits,
	virtualMenu,
	virtualPagination,
	virtualSearchBox
}

